import { CIProvider, CIProviderStepOneTokenProps } from "../types";

export const SETUP_CI_TOKEN_PROPS_BY_PROVIDER: {
  [key in CIProvider]: CIProviderStepOneTokenProps;
} = {
  github: {
    secretName: "secret",
    secretDocsHref:
      "https://docs.github.com/en/actions/configuring-and-managing-workflows/creating-and-storing-encrypted-secrets",
  },
  gitlab: {
    secretName: "CI/CD variable",
    secretDocsHref:
      "https://docs.gitlab.com/ee/ci/variables/#custom-cicd-variables",
  },
  jenkins: {
    secretName: "credential",
    secretDocsHref: "https://www.jenkins.io/doc/book/using/using-credentials/",
  },
  bitbucket: {
    secretName: "repository variable",
    secretDocsHref:
      "https://support.atlassian.com/bitbucket-cloud/docs/variables-and-secrets/#Repository-variables",
  },
  circleci: {
    secretName: "environment variable",
    secretDocsHref: "https://circleci.com/docs/env-vars",
  },
  buildkite: {
    secretName: "pipeline secret",
    secretDocsHref: "https://buildkite.com/docs/pipelines/secrets",
  },
  azure: {
    secretName: "group variable",
    secretDocsHref:
      "https://docs.microsoft.com/en-us/azure/devops/pipelines/library/variable-groups?view=azure-devops&tabs=yaml",
  },
};
